/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';

import { StyledModal, Button, Spinner, useFlags } from 'sarsaparilla';

import styles from './ActivityTagFeedbackModal.module.scss';

export function ActivityTagFeedbackModal() {
    const { searchProvideFeedback } = useFlags();
    const [isOpen, setIsOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);

    if (!searchProvideFeedback?.enabled) {
        return null;
    }

    return (
        <>
            <span className={styles.expander} />

            <Button
                appearance="link"
                onClick={() => {
                    setIsLoading(true);
                    setIsOpen(true);
                }}
            >
                Provide Feedback
            </Button>

            <StyledModal
                isOpen={isOpen}
                onRequestClose={() => {
                    setIsOpen(false);
                }}
                size="xl"
                heading="Provide Search Feedback"
            >
                <div className={styles.iframeContainer}>
                    {isLoading && (
                        <div className={styles.spinnerOverlay}>
                            <Spinner />
                        </div>
                    )}
                    <iframe
                        title="Provide feedback on search"
                        src={searchProvideFeedback.url}
                        className={styles.iframe}
                        onLoad={() => {
                            setIsLoading(false);
                        }}
                        style={{
                            // this is to turn off iframe's native spinner
                            display: isLoading ? 'none' : 'block',
                        }}
                    />
                </div>
            </StyledModal>
        </>
    );
}
